import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from '@/src/i18n';

const PaybackIndications = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={3}>
      <Typography>{t('payback-indications-intro')}</Typography>
      <Box>
        <Typography variant="h6">{t('sector-number', { value: 1 })}</Typography>
        <Typography>{t('payback-indications-sector-1')}</Typography>
      </Box>
      <Box>
        <Typography variant="h6">{t('sector-number', { value: 2 })}</Typography>
        <Typography>{t('payback-indications-sector-2')}</Typography>
      </Box>
      <Box>
        <Typography variant="h6">{t('sector-number', { value: 3 })}</Typography>
        <Typography>{t('payback-indications-sector-3')}</Typography>
      </Box>

      <Box>
        <Button
          variant="text"
          target="_blank"
          rel="noopener noreferrer"
          href="https://fr.wikipedia.org/wiki/Convention_m%C3%A9dicale"
          sx={{
            color: theme => theme.palette.text.link,
            fontSize: 14,
            textDecoration: 'underline',
            px: 0,
            minWidth: 0,
          }}
        >
          {t('to-know-more')}
        </Button>
      </Box>
    </Stack>
  );
};

export default PaybackIndications;
